import { render, staticRenderFns } from "./ChangeButton.vue?vue&type=template&id=f5fc695c&scoped=true"
import script from "./ChangeButton.vue?vue&type=script&lang=js"
export * from "./ChangeButton.vue?vue&type=script&lang=js"
import style0 from "./ChangeButton.vue?vue&type=style&index=0&id=f5fc695c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fc695c",
  null
  
)

export default component.exports